"use strict"
module.exports = {
  en: require("./en"),
  ar: require("./ar"),
  ca: require("./ca"),
  cs: require("./cs"),
  de: require("./de"),
  es: require("./es"),
  fi: require("./fi"),
  fr: require("./fr"),
  hu: require("./hu"),
  id: require("./id"),
  it: require("./it"),
  ja: require("./ja"),
  ko: require("./ko"),
  nb: require("./nb"),
  nl: require("./nl"),
  pl: require("./pl"),
  "pt-BR": require("./pt-BR"),
  ru: require("./ru"),
  sk: require("./sk"),
  sv: require("./sv"),
  th: require("./th"),
  zh: require("./zh"),
  "zh-TW": require("./zh-TW"),
}
